import { jsx } from "react/jsx-runtime";
import { useBlockEnvironment, ApexFormTwoColumn } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import { getDefaultApexFieldValues } from "../ApexForm/ApexForm.esm.js";
const BlockApexFormTwoColumn = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    environment = "prod"
  } = useBlockEnvironment();
  const defaultValues = getDefaultApexFieldValues(innerBlocks);
  const endpoint = environment === "prod" ? "https://zg-api.com/interested-party/submit" : "https://zg-api.test.zillow.net/interested-party/submit";
  return /* @__PURE__ */ jsx(ApexFormTwoColumn, { defaultValues, ...attrs, endpoint, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
BlockApexFormTwoColumn.propTypes = {
  index: PropTypes.number,
  id: PropTypes.string,
  attrs: PropTypes.shape({
    businessLine: PropTypes.string.isRequired,
    warmLeadSource: PropTypes.string.isRequired,
    fullWidthFieldCount: PropTypes.number
  })
};
BlockApexFormTwoColumn.defaultProps = {
  id: void 0,
  index: void 0,
  attrs: {
    businessLine: "",
    warmLeadSource: ""
  }
};
export {
  BlockApexFormTwoColumn as default
};
